import palette from './palette'

const theme = {
  palette
} as const

export default theme

export { palette }
